import { History, X, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { SearchHistoryItem } from "@/hooks/useSearchHistory";

interface SearchHistoryDropdownProps {
  history: SearchHistoryItem[];
  onSelectItem: (query: string) => void;
  onRemoveItem: (query: string) => void;
  onClearAll: () => void;
  isVisible: boolean;
  searchType: "oem" | "ref";
}

export const SearchHistoryDropdown = ({
  history,
  onSelectItem,
  onRemoveItem,
  onClearAll,
  isVisible,
  searchType,
}: SearchHistoryDropdownProps) => {
  if (!isVisible || history.length === 0) return null;

  return (
    <div className="absolute top-full left-0 right-0 mt-1 z-50 bg-popover border border-border rounded-lg shadow-lg">
      <div className="flex items-center justify-between px-3 py-2 border-b border-border">
        <div className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
          <History className="h-3 w-3" />
          Historique {searchType === "oem" ? "OEM" : "Référence"}
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="h-6 text-xs text-muted-foreground hover:text-destructive"
          onClick={onClearAll}
        >
          <Trash2 className="h-3 w-3 mr-1" />
          Tout effacer
        </Button>
      </div>
      <ScrollArea className="max-h-[240px]">
        <div className="p-2 space-y-1">
          {history.map((item) => (
            <div
              key={`${item.query}-${item.timestamp}`}
              className="group flex items-center justify-between px-3 py-2 rounded-md hover:bg-accent/50 transition-colors cursor-pointer"
              onClick={() => onSelectItem(item.query)}
            >
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <span className="font-mono text-sm truncate">{item.query}</span>
                <Badge variant="outline" className="text-[10px] px-1.5 py-0 h-4 flex-shrink-0">
                  {item.type.toUpperCase()}
                </Badge>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="h-6 w-6 p-0 opacity-0 group-hover:opacity-100 transition-opacity ml-2 flex-shrink-0"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveItem(item.query);
                }}
              >
                <X className="h-3 w-3" />
              </Button>
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};
